// extracted by mini-css-extract-plugin
export var circle = "_h2-1";
export var exitConfirmationModal = "_h2-5";
export var iframe = "_h2-0";
export var offline = "_h2-3";
export var online = "_h2-2";
export var workstationSelectError = "_h2-4";